export default {
  FlowClassRule: 'Traffic classification rules',
  SpeedLimitRule: 'Speed limit configuration',
  RelationErr: 'Associate Error',
  GatewayMoreThen10: (names: string) => `The number of policies associated with gateway ${names} has reached the upper limit, further associations will exclude the above gateways from further submissions.`,
  ContinueRelation: 'Continue to Associate',
  ApplicationScope: 'Application scope',
}